import API from "./baseApi";

//=============User Management=============
const getUsers = (payload) => {
  return API.post("/users/getAllUsers", payload);
};

const createUser = (payload) => {
  return API.post("/auth/signup", payload);
};

const updateUser = (id, payload, headers) => {
  return API.patch(`/users/${id}`, payload, headers);
};

const deleteUser = (id, payload) => {
  return API.delete(`/users/${id}`, payload);
};

// const getUsers = (payload) => {
//   return API.get("/users/getAllUsers", payload);
// };

//=============Role Management=============
const getRoleAccessByEmail = (payload) => {
  return API.post(`/roles/find-by-email`, payload);
};

const getRoles = (payload) => {
  if (payload && Object.keys(payload).length) {
    let query = "?";
    Object.keys(payload).map((x) => {
      if (payload[x] !== undefined && payload[x] !== null) {
        let value = payload[x];
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        query = query + `${x}=${value}&`;
      }
    });
    return API.get("/roles" + query, payload);
  } else {
    return API.get("/roles")
  }
};

const createRole = (payload) => {
  return API.post("roles/create", payload);
};

const updateRole = (id, payload) => {
  return API.post(`/roles/update/${id}`, payload);
};

// ===============Permission Management=============

const getPermissions = (payload) => {
  return API.post("/roles/get-permission", payload);
};

const createPermissions = (payload) => {
  return API.post("/roles/create-permission", payload);
};

const deletePermissions = (id) => {
  return API.delete(`/roles/delete/permission/${id}`);
};

const getPrograms = (payload) => {
  return API.post("/programs/get", payload);
};

const getServices = (payload) => {
  return API.post("/services/get", payload);
};

const getSubServices = (payload) => {
  return API.post("/services/subservices/get", payload);
};

const getCurrentUser = (id) => {
  return API.get(`/users/${id}`);
};

export default {
  //User Management
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  //Role Management
  getRoles,
  createRole,
  getPrograms,
  getServices,
  getSubServices,
  updateRole,
  getPermissions,
  createPermissions,
  deletePermissions,
  getRoleAccessByEmail,
  getCurrentUser,
};
